import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';

import { accountService, alertService } from '../../_services';

function AddEdit({ history, match }) {
    const { id } = match.params;
    const isAddMode = !id;

    const [init, setInit] = useState({
        firstName: '',
        lastName: '',
        email: '',
        role: '',
        password: '',
        confirmPassword: '',
        allowedReservations: 1
    });

    useEffect(() => {
        async function fetchData() {
            const init = await accountService.getById(id);
            console.log(init);
            setInit(init);
        }
        fetchData();
    }, []);

    const validationSchema = Yup.object().shape({
        firstName: Yup.string()
            .required('First Name is required'),
        lastName: Yup.string()
            .required('Last Name is required'),
        password: Yup.string()
            .concat(isAddMode ? Yup.string().required('Password is required') : null)
            .min(6, 'Password must be at least 6 characters'),
        confirmPassword: Yup.string()
            .when('password', (password, schema) => {
                if (password) return schema.required('Confirm Password is required');
            })
            .oneOf([Yup.ref('password')], 'Passwords must match'),
        allowedReservations: Yup.number()
            .required('Total Allowed Reservations is required')
    });

    function onSubmit(fields, { setStatus, setSubmitting }) {
        setStatus();
        if (isAddMode) {
            createUser(fields, setSubmitting);
        } else {
            updateUser(id, fields, setSubmitting);
        }
    }

    function createUser(fields, setSubmitting) {
        accountService.create(fields)
            .then(() => {
                alertService.success('User added successfully', { keepAfterRouteChange: true });
                history.push('.');
            })
            .catch(error => {
                setSubmitting(false);
                alertService.error(error);
            });
    }

    function updateUser(id, fields, setSubmitting) {
        accountService.update(id, fields)
            .then(() => {
                alertService.success('Update successful', { keepAfterRouteChange: true });
                history.push('..');
            })
            .catch(error => {
                setSubmitting(false);
                alertService.error(error);
            });
    }

    return (
        <Formik enableReinitialize={true} initialValues={init} validationSchema={validationSchema} onSubmit={onSubmit}>
            {({ errors, touched, isSubmitting, setFieldValue }) => {
                return (
                    <Form>
                        <div className="card-header header-admin">
                            <h2 className="bold-tx">{isAddMode ? 'Add User:' : 'Edit User:'}</h2>
                            <br />
                            <h4 className="bold-tx">{init.email} </h4>
                        </div>

                        <h4 className="card-header admin-subheader-2 admin-subheader">Change Name</h4>

                        <div className="form-row">
                            <div className="form-group col-6 first-name-marg">
                                <label>First Name</label>
                                <Field name="firstName" type="text" className={'form-control' + (errors.firstName && touched.firstName ? ' is-invalid' : '')} />
                                <ErrorMessage name="firstName" component="div" className="invalid-feedback" />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-6 last-name-marg">
                                <label>Last Name</label>
                                <Field name="lastName" type="text" className={'form-control' + (errors.lastName && touched.lastName ? ' is-invalid' : '')} />
                                <ErrorMessage name="lastName" component="div" className="invalid-feedback" />
                            </div>
                        </div>

                        <h4 className="card-header admin-subheader-2 admin-subheader">Change Role</h4>
                        <div className="form-row">
                            <div className="form-group col-6 role-marg">
                                <label>Role</label>
                                <Field name="role" as="select" className={'form-control' + (errors.role && touched.role ? ' is-invalid' : '')}>
                                    <option value="User">User</option>
                                    <option value="LockerAdmin">Locker Admin</option>
                                    <option value="Admin">Admin</option>
                                </Field>
                                <ErrorMessage name="role" component="div" className="invalid-feedback" />
                            </div>
                        </div>
                        {!isAddMode &&
                            <div>
                                <h4 className="card-header admin-subheader-2 admin-subheader">Change Password</h4>
                                <p className="rent-agree-marg">Leave blank to keep the same password</p>
                            </div>
                        }
                        <div className="form-row">
                            <div className="form-group col-6 first-name-marg">
                                <label>Password</label>
                                <Field name="password" type="password" className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')} />
                                <ErrorMessage name="password" component="div" className="invalid-feedback" />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-6 last-name-marg">
                                <label>Confirm Password</label>
                                <Field name="confirmPassword" type="password" className={'form-control' + (errors.confirmPassword && touched.confirmPassword ? ' is-invalid' : '')} />
                                <ErrorMessage name="confirmPassword" component="div" className="invalid-feedback" />
                            </div>
                        </div>
                        <h4 className="card-header admin-subheader-2 admin-subheader">Change Allowed Reservations</h4>
                        <div className="form-row">
                            <div className="form-group col-6 last-name-marg">
                                <label>Total Reservations</label>
                                <div className="form-group col-4">
                                    <Field style={{ 'textAlign' : 'center'}} name="allowedReservations" type="number" min="1" max="200" className={'form-control' + (errors.allowedReservations && touched.allowedReservations ? ' is-invalid' : '')} />
                                </div>
                                <ErrorMessage name="allowedReservations" component="div" className="invalid-feedback" />
                            </div>
                        </div>
                        <div className="form-group">
                            <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                                {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                Save
                            </button>
                        </div>
                        <div className="cust-ft-top">
                            <h3 className="card-header cust-footer">
                                <Link to={isAddMode ? '.' : '..'} className="btn btn-link">Cancel</Link>
                            </h3>
                        </div>
                    </Form>
                );
            }}
        </Formik>
    );
}

export { AddEdit };